<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere eliminar al accionista?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteAccionista">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="accionista-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putAccionista)">
          <ModalCapitalAccionista :currentAccionista="currentAccionista" @submit.prevent @calcular="calcularCapitales" />
        </form>
      </ValidationObserver>
    </b-modal>

    <h4 class="cardD">Datos generales del Capital y de los Accionistas</h4>

    <div class="row mt-4">
      <div class="col-md-6">
        <ValidationProvider
          name="capital_fijo"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{
            required: 'El capital fijo es obligatorio',
          }"
        >
          <b-form-group
            :label="'Monto de Capital Fijo: ' + formatCurrency(constitutiva.capital_fijo)"
            label-for="capital-fijo-input"
          >
            <b-form-input
              id="capital-fijo-input"
              type="number"
              v-model="constitutiva.capital_fijo"
              :disabled="disabledDatosCapital"
              placeholder="$"
              @input="calcularCapitales"
            ></b-form-input>
            <span class="cardErrors">{{ errors[0] }}</span>
          </b-form-group>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <label for="check-constitutiva-capital-extranjero">Hay Personas Físicas extranjeras</label>
        <div v-if="constitutiva.roleStaff">
          <b-form-checkbox
            id="check-constitutiva-capital-extranjero"
            v-model="constitutiva.capital_extranjero"
            :disabled="disabledDatosCapital"
          ></b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox
            id="check-constitutiva-capital-extranjero"
            v-model="constitutiva.capital_extranjero"
            :disabled="disabledDatosCapital"
          ></b-form-checkbox>
        </div>

        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.capital_extranjero">
          La cotización básica no incluye capital extranjero.
        </label>
      </div>
    </div>

    <div class="mt-4">
      <label for="">Cuadro Accionario</label>
      <b-button
        v-if="constitutiva.roleStaff"
        :disabled="disabledDatosCapital"
        variant="success"
        class="btn-fill spaceL"
        size="sm"
        @click="addAccionista"
      >
        +
      </b-button>
    </div>

    <div class="mt-4">
      <label for="">Seleccionar Comparecientes</label>
      <select
        class="custom-select"
        v-model="selectedCompareciente"
        @change="selectCompareciente"
        :disabled="disabledDatosCapital"
      >
        <option v-for="option in options_comparecientes" :key="option.value" v-bind:value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>

    <div>
      <b-table ref="tableAccionistas" hover :fields="fieldsCuadro" :items="constitutiva.accionistas">
        <template #cell(index)="{ index }">
          {{ getIndex(index) }}
        </template>
        <template #cell(nombreCompleto)="{ item }">
          {{ getFullName(item) }}
        </template>
        <template #cell(capital_fijo)="{ item }">
          {{ formatCurrency(item.capital_fijo) }}
        </template>
        <template #cell(capital_fijo)="{ item }">
          {{ formatCurrency(item.capital_fijo) }}
        </template>
        <template #cell(acciones)="{ item }">
          <b-button
            :disabled="disabledDatosCapital"
            variant="warning"
            size="sm"
            v-b-tooltip.hover
            title="Editar"
            class="editBtn"
            @click="editAccionista(item)"
          >
            <b-icon-pencil />
          </b-button>
          <b-button
            v-if="constitutiva.roleStaff"
            :disabled="disabledDatosCapital"
            variant="danger"
            size="sm"
            v-b-tooltip.hover
            title="Eliminar"
            @click="predeleteAccionista(item)"
          >
            <b-icon-trash />
          </b-button>
        </template>
      </b-table>
      <label v-if="totalPorcentajes != null" for="">Total {{ totalPorcentajes }} %</label>
      <p></p>
      <ValidationProvider name="porcentaje_total" rules="cien" v-slot="{ errors }">
        <input type="text" v-model="totalPorcentajes" hidden />
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.accionistas.length > 2">
      La cotización básica incluye solo 2 accionistas personas físicas.
    </label>

    <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.accionistas.length < 2">
      Se deben agregar mínimo 2 accionistas.
    </label>

    <div class="mt-4">
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button
            type="submit"
            class="btn-fill orange-btn"
            :disabled="disabledDatosCapital || constitutiva.accionistas.length < 2"
          >
            Guardar
          </b-button>
          <b-button
            variant="success"
            class="btn-fill"
            :disabled="disabledDatosCapital || constitutiva.accionistas.length < 2"
            @click="validar"
          >
            Validar
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ModalCapitalAccionista from "@/views/clients/procesos/constitucion/infoBase/modales/ModalCapitalAccionista.vue";

import { ComparecientesApi } from "@/api";
import { formatCurrency } from "@/utils/number-utils";

export default {
  name: "TabDatosCapital",

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center" },
        { key: "persona", label: "Persona", class: "text-center" },
        { key: "porcentaje", label: "Porcentaje", class: "text-center" },
        { key: "capital_fijo", label: "Capital Fijo", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },

    disabledDatosCapital() {
      const formulario = this.constitutiva.formularios.find((f) => f.formulario === "DatosCapital");

      return formulario?.valido == 1;
    },
  },

  created() {
    this.calcularCapitales();
    this.getComparecientes();
  },

  components: {
    ModalCapitalAccionista,
  },

  props: {
    constitutiva: { type: Object },
  },

  data() {
    return {
      loading: false,
      comparecientes: [],
      options_comparecientes: [],
      selectedCompareciente: null,

      currentAccionistaId: null,
      currentAccionista: null,
      totalPorcentajes: null,

      form: {
        capital_fijo: null,
        capital_variable: null,
        accionistas: [],
        totalPorcentajesF: null,
        capital_extranjero: null,
      },
    };
  },

  methods: {
    formatCurrency,

    getFullName(compareciente) {
      let nombreCompleto = compareciente.denominacion_social;

      if (compareciente.persona.includes("Física")) {
        nombreCompleto = `${compareciente.nombre} ${compareciente.paterno} ${compareciente.materno || ""}`.trimEnd();
      }

      return nombreCompleto;
    },

    getIndex(index) {
      return index + 1;
    },

    async getComparecientes() {
      try {
        this.loading = true;

        const { value } = await ComparecientesApi.combo({
          clientes_id: this.constitutiva.clientes_id,
        });

        value.forEach((element) => {
          let nombreTotal = "";
          if (element.persona === "Física") {
            nombreTotal = `${element.nombre} ${element.paterno} ${element.materno || ""}`.trimEnd();
          } else {
            nombreTotal = element.denominacion_social;
          }
          const obj = {
            text: nombreTotal,
            value: element.id,
          };
          this.options_comparecientes.push(obj);

          element.nombreCompleto = nombreTotal;
          element.persona = `Persona ${element.persona}`;
          element.rfc = element.rfc;
        });

        this.comparecientes = value;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    selectCompareciente() {
      let indexYa = this.constitutiva.accionistas.findIndex((o) => o.id === this.selectedCompareciente);

      // console.log(this.selectedCompareciente);
      // console.log(indexYa);
      if (indexYa != -1) {
        this.$toast.warning("No se puede seleccionar 2 veces al mismo compareciente", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      let index = this.comparecientes.findIndex((o) => o.id === this.selectedCompareciente);

      // console.log(this.comparecientes[index]);
      this.comparecientes[index].capital_fijo = 0;
      this.comparecientes[index].capital_variable = 0;
      this.comparecientes[index].porcentaje = 0;
      this.comparecientes[index].rfc = this.comparecientes[index].rfc;

      const a = Object.assign({}, this.comparecientes[index]);
      a.index = this.constitutiva.accionistas.length + 1;

      this.constitutiva.accionistas.push(a);
    },

    calcularCapitales() {
      let totalPorcentajes = 0;
      for (let i = 0; i < this.constitutiva.accionistas.length; i++) {
        let capital_fijo = (this.constitutiva.accionistas[i].porcentaje * this.constitutiva.capital_fijo) / 100;

        this.constitutiva.accionistas[i].capital_fijo = capital_fijo;

        // let capital_variable = (this.constitutiva.accionistas[i].porcentaje * this.constitutiva.capital_variable) / 100;
        // this.constitutiva.accionistas[i].capital_variable = capital_variable;

        totalPorcentajes = totalPorcentajes + parseFloat(this.constitutiva.accionistas[i].porcentaje);

        // const a = Object.assign({}, this.constitutiva.accionistas[i]);
        // this.constitutiva.accionistas.splice([i], 1, a);
        // this.constitutiva.accionistas[i] = a;
      }
      this.totalPorcentajes = totalPorcentajes;

      try {
        this.$refs.tableAccionistas.refresh();
      } catch (error) {}
    },

    addAccionista() {
      this.$refs["accionista-modal"].show();
      this.currentAccionista = {};
      this.currentAccionista.capital_fijo = 0;
      this.currentAccionista.capital_variable = 0;
    },

    editAccionista(item) {
      this.$refs["accionista-modal"].show();
      this.currentAccionista = item;
    },

    putAccionista() {
      const exists = this.constitutiva.accionistas.indexOf(this.currentAccionista);

      if (exists === -1) {
        let nombre = "";
        if (this.currentAccionista.persona === "Persona Física") {
          nombre = `${this.currentAccionista.nombre} ${this.currentAccionista.paterno} ${this.currentAccionista.materno}`;
        } else {
          nombre = `${this.currentAccionista.denominacion_social}`;
        }
        this.currentAccionista.nombreCompleto = nombre;
        this.currentAccionista.visible = 1;

        this.constitutiva.accionistas.push(this.currentAccionista);
      }

      this.calcularCapitales();
      this.$refs["accionista-modal"].hide();
    },

    predeleteAccionista(id) {
      this.currentAccionistaId = id;
      this.$refs["modal-confirm-dialog"].show();
    },

    deleteAccionista() {
      const index2 = this.constitutiva.accionistas.indexOf(this.currentAccionistaId);

      this.constitutiva.accionistas.splice(index2, 1);
      this.calcularCapitales();
      this.$refs["modal-confirm-dialog"].hide();
    },

    validar() {
      this.$emit("validaForm", "DatosCapital");
    },
  },
};
</script>

<style scoped>
.spaceL {
  margin-left: 1%;
}
</style>
